<template>
  <div id="app">
    <Nav/>
    <router-view/>
    <footer-box />
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  import FooterBox from '@/components/FooterBox'

  export default {
    name: 'App',
    components: {
      FooterBox,
      Nav
    },
  }
</script>

<style lang="scss">
  @import url("https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css");
  @import url("https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/css/bootstrap-grid.min.css");
  @import url("https://fonts.googleapis.com/css?family=Montserrat:300,400,700");

  body
  {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a
  {
    text-decoration: none;

    color: inherit;
  }

  button
  {
    cursor: pointer;

    &:focus
    {
      outline: 0;
    }
  }

  .text-center
  {
    text-align: center;
  }

  .img-fluid
  {
    max-width: 100%;
    height: auto;
  }
</style>
